import React, { ReactNode } from 'react';
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material';

import { isChMachineUser, isDemoOrganizationUser, isG2User, isTrussWorksUser } from '@paragon/login-tools';

import { isUsingDarkTheme } from '../selectors/themeSelectors';
import { useAppWithThemeSelector } from './hooks';

interface Props {
  readonly darkTheme: Theme;
  readonly lightTheme: Theme;
  readonly g2Theme?: Theme;
  readonly trussWorksTheme?: Theme;
  readonly demoTheme?: Theme;
  readonly chTheme?: Theme;
  readonly children?: ReactNode;
}

export function ParagonThemeProvider(props: Props) {
  const useG2Theme = useAppWithThemeSelector(isG2User);
  const useTrussWorksTheme = useAppWithThemeSelector(isTrussWorksUser);
  const useDemoTheme = useAppWithThemeSelector(isDemoOrganizationUser);
  const useCHTheme = useAppWithThemeSelector(isChMachineUser);
  const useDarkTheme = useAppWithThemeSelector(isUsingDarkTheme);

  let theme: Theme;
  if (props.g2Theme && useG2Theme) {
    theme = props.g2Theme;
  } else if (props.trussWorksTheme && useTrussWorksTheme) {
    theme = props.trussWorksTheme;
  } else if (props.demoTheme && useDemoTheme) {
    theme = props.demoTheme;
  } else if (props.chTheme && useCHTheme) {
    theme = props.chTheme;
  } else if (useDarkTheme) {
    theme = props.darkTheme;
  } else {
    theme = props.lightTheme;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
